<template>
    <div class="row" style="margin-bottom: 35px;">
        <div class="col-md-12" style="padding-right: 5px !important;">
            <div class="d-flex justify-content-center justify-content-md-end">
                <div class="btn-group">
                    <button @click="scrollToContactOwner" type="button" class="btn btn-secondary" id="contactOwnerButton" style="">{{ $t('components.contactOwnerButtons.contact') }}</button>
                    <button @click="scrollToCheckAvailability" type="button" class="btn btn-secondary" id="checkAvailabilityButton" style="">{{ $t('components.contactOwnerButtons.availability') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContactOwnerButtons',
    methods: {
        scrollToContactOwner: function() {
            $("html, body").animate({
                scrollTop: $("#contactContainer").offset().top - $(header).height() - 110,
            }, 1000);
        },
        scrollToCheckAvailability: function() {
            $("html, body").animate({
                scrollTop: $("#availabiltyContainer").offset().top - $(header).height() - 90,
            }, 1000);
        }
    }
}
</script>